"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4595],{

/***/ 1169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ form_TokenSelector; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/TextInput/TextInput.js
var TextInput = __webpack_require__(80061);
// EXTERNAL MODULE: ./src/form/utils/urlToHttp.ts
var urlToHttp = __webpack_require__(69545);
// EXTERNAL MODULE: ./node_modules/react-window/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(1314);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/wagmi/dist/index.js + 25 modules
var dist = __webpack_require__(69077);
// EXTERNAL MODULE: ./src/form/utils/validate.ts
var validate = __webpack_require__(65746);
;// CONCATENATED MODULE: ./src/form/hooks/useERC20Info.ts




function useERC20Info(address, chain) {
    var isValid = (0,validate/* isValidAddress */.At)(address || "") && !!chain;
    var ref = (0,dist/* useToken */.dQ)({
        address: address,
        chainId: chain,
        enabled: isValid
    }), data = ref.data, isLoading = ref.isLoading, error = ref.error;
    return {
        info: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
            chainId: chain
        }),
        isLoading: isLoading,
        error: error
    };
}

;// CONCATENATED MODULE: ./src/form/services/abi/ERC721.ts
/* harmony default export */ var ERC721 = ([
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "owner",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "approved",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "uint256",
                "name": "tokenId",
                "type": "uint256"
            }
        ],
        "name": "Approval",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "owner",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "operator",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "bool",
                "name": "approved",
                "type": "bool"
            }
        ],
        "name": "ApprovalForAll",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "from",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "to",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "uint256",
                "name": "tokenId",
                "type": "uint256"
            }
        ],
        "name": "Transfer",
        "type": "event"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "to",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "tokenId",
                "type": "uint256"
            }
        ],
        "name": "approve",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "constant": true,
        "inputs": [],
        "name": "totalSupply",
        "outputs": [
            {
                "name": "",
                "type": "uint256"
            }
        ],
        "payable": false,
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "owner",
                "type": "address"
            }
        ],
        "name": "balanceOf",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "balance",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "tokenId",
                "type": "uint256"
            }
        ],
        "name": "getApproved",
        "outputs": [
            {
                "internalType": "address",
                "name": "operator",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "owner",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "operator",
                "type": "address"
            }
        ],
        "name": "isApprovedForAll",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "name",
        "outputs": [
            {
                "internalType": "string",
                "name": "",
                "type": "string"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "tokenId",
                "type": "uint256"
            }
        ],
        "name": "ownerOf",
        "outputs": [
            {
                "internalType": "address",
                "name": "owner",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "from",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "to",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "tokenId",
                "type": "uint256"
            }
        ],
        "name": "safeTransferFrom",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "from",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "to",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "tokenId",
                "type": "uint256"
            },
            {
                "internalType": "bytes",
                "name": "data",
                "type": "bytes"
            }
        ],
        "name": "safeTransferFrom",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "operator",
                "type": "address"
            },
            {
                "internalType": "bool",
                "name": "_approved",
                "type": "bool"
            }
        ],
        "name": "setApprovalForAll",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "bytes4",
                "name": "interfaceId",
                "type": "bytes4"
            }
        ],
        "name": "supportsInterface",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "symbol",
        "outputs": [
            {
                "internalType": "string",
                "name": "",
                "type": "string"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "tokenId",
                "type": "uint256"
            }
        ],
        "name": "tokenURI",
        "outputs": [
            {
                "internalType": "string",
                "name": "",
                "type": "string"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "from",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "to",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "tokenId",
                "type": "uint256"
            }
        ],
        "name": "transferFrom",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    }
]);

;// CONCATENATED MODULE: ./src/form/hooks/useERC721Info.ts



function useERC721Info(address, chain) {
    var isValid = (0,validate/* isValidAddress */.At)(address || "") && !!chain;
    var ref = (0,dist/* useContractRead */["do"])({
        address: isValid ? address : undefined,
        abi: ERC721,
        chainId: chain,
        functionName: "name"
    }), data = ref.data, isLoading = ref.isLoading, error = ref.error;
    return {
        info: {
            chainId: chain,
            name: data,
            address: address
        },
        isLoading: isLoading,
        error: error
    };
}

// EXTERNAL MODULE: ./src/form/services/chain.ts
var services_chain = __webpack_require__(50072);
;// CONCATENATED MODULE: ./src/form/components/form/TokenSelector.tsx










var TokenSelector = function(param) {
    var formik = param.formik, path = param.path, data = param.data, chain = param.chain, _ariaLabel = param.ariaLabel, ariaLabel = _ariaLabel === void 0 ? "token selector" : _ariaLabel, onChange = param.onChange, onFocus = param.onFocus, onBlur = param.onBlur, inputStyle = param.inputStyle, _dropdownClass = param.dropdownClass, dropdownClass = _dropdownClass === void 0 ? "" : _dropdownClass, hideNativeCurrency = param.hideNativeCurrency;
    var ref;
    var ref1 = (0,react.useState)(false), dropdownShow = ref1[0], setDropdownShow = ref1[1];
    var inputRef = (0,react.useRef)(null);
    var listRef = (0,react.useRef)(null);
    var ref2 = (0,react.useState)(undefined), filter = ref2[0], setFilter = ref2[1];
    var tokenList = data.filter(function(token) {
        return String(token.chainId) === chain;
    });
    var nativeCurrency = services_chain/* nativeCurrencys */.GS[Number(chain)];
    if (nativeCurrency && !hideNativeCurrency) {
        tokenList.unshift(nativeCurrency);
    }
    var filterData = filter ? tokenList.filter(function(item) {
        var text = "".concat(item.name, "_").concat(item.symbol, "_").concat(item.address).toLowerCase();
        return text.indexOf(filter.toLowerCase()) > -1;
    }) : tokenList;
    var info = useERC20Info(filterData.length === 0 ? filter : "", Number(chain)).info;
    var ref3 = useERC721Info(filterData.length === 0 ? filter : "", Number(chain)), nftInfo = ref3.info;
    if (filterData.length === 0 && info.address) {
        filterData.unshift(info);
    }
    if (filterData.length === 0 && nftInfo.address) {
        filterData.unshift(nftInfo);
    }
    var findIndex = filterData.findIndex(function(item) {
        var ref;
        return item.address === ((ref = lodash_default().get(formik.values, path)) === null || ref === void 0 ? void 0 : ref.address);
    });
    var ref4 = (0,react.useState)(findIndex === -1 ? 0 : findIndex), activeIndex = ref4[0], setActiveIndex = ref4[1];
    (0,react.useEffect)(function() {
        if (inputRef.current) {
            inputRef.current.value = "";
        }
        setActiveIndex(0);
    }, [
        chain,
        inputRef
    ]);
    (0,react.useEffect)(function() {
        if (dropdownShow && listRef.current) {
            listRef.current.scrollToItem(activeIndex, "center");
        }
    }, [
        dropdownShow,
        activeIndex
    ]);
    var onInputFocus = (0,react.useCallback)(function() {
        setDropdownShow(true);
        setFilter(undefined);
    }, []);
    var onInputBlur = (0,react.useCallback)(function() {
        setTimeout(function() {
            setDropdownShow(false);
        }, 200);
    }, []);
    var onUserInput = (0,react.useCallback)(function(e) {
        var code = e.code;
        var totalCount = filterData.length;
        if (code === "ArrowUp" || code === "ArrowDown") {
            var index;
            if (code === "ArrowUp") {
                index = activeIndex - 1;
            } else {
                index = activeIndex + 1;
            }
            if (index < 0) {
                index = totalCount + index;
            } else if (index > totalCount - 1) {
                index = index - totalCount;
            }
            setActiveIndex(index);
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        if (code === "Enter") {
            var token = filterData[activeIndex];
            formik.setFieldValue(path, token || undefined);
            if (token) {
                onChange && onChange(token);
            }
            if (inputRef.current) {
                inputRef.current.value = token.name;
                inputRef.current.blur();
            }
            setDropdownShow(false);
            return;
        }
        if (code === "Escape") {
            var ref;
            (ref = inputRef.current) === null || ref === void 0 ? void 0 : ref.blur();
            setDropdownShow(false);
            return;
        }
        if (code !== "ArrowRight" && code !== "ArrowLeft") {
            var ref1;
            setFilter(((ref1 = inputRef.current) === null || ref1 === void 0 ? void 0 : ref1.value) || "");
        }
    }, [
        inputRef,
        activeIndex,
        filterData
    ]);
    var onSelect = (0,react.useCallback)(function(index, token) {
        if (inputRef.current && token) {
            inputRef.current.value = token.name;
            formik.setFieldValue(path, token || undefined);
            onChange && onChange(token || undefined);
            setActiveIndex(index);
            setDropdownShow(false);
        }
    }, [
        onChange
    ]);
    var Row = function(param) {
        var style = param.style, index = param.index, data = param.data;
        var item = data.list[index];
        var onSelect = (0,react.useCallback)(function(e) {
            var index = parseInt(e.currentTarget.dataset.index, 10);
            data.onSelect(index, data.list[index]);
        }, [
            data.list
        ]);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            onClick: onSelect,
            "data-index": index,
            className: "flex cursor-pointer items-center rounded px-2 text-body hover:bg-gray_e4 ".concat(index == data.activeIndex ? "bg-primary text-white" : ""),
            style: style,
            role: "listitem",
            "aria-label": item.name,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: "mr-2 rounded-[50%]",
                    src: (0,urlToHttp/* default */.Z)(item.logoURI)[0],
                    width: 20,
                    height: 20,
                    loading: "lazy"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: item.name
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
                id: path,
                onChange: function(e) {
                    setFilter(e.currentTarget.value);
                },
                rightSectionWidth: 50,
                className: "border-none",
                styles: {
                    input: (0,_object_spread/* default */.Z)({
                        border: "none",
                        cursor: "pointer",
                        padding: "0px",
                        background: "transparent"
                    }, inputStyle)
                },
                type: "text",
                role: "textbox",
                "aria-label": ariaLabel,
                ref: inputRef,
                autoFocus: false,
                onKeyUp: onUserInput,
                onFocus: function(e) {
                    onInputFocus();
                    onFocus && onFocus();
                },
                onBlur: function(e) {
                    setTimeout(function() {
                        onInputBlur();
                        setFilter(undefined);
                        formik.handleBlur(e);
                        onBlur && onBlur();
                    }, 200);
                },
                autoComplete: "off",
                spellCheck: false,
                placeholder: "Search or paste address",
                value: filter === "" ? "" : filter || ((ref = lodash_default().get(formik.values, path)) === null || ref === void 0 ? void 0 : ref.name)
            }),
            dropdownShow && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute top-[49px] z-20  w-full  rounded border  bg-white ".concat(dropdownClass),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pl-2 pr-3 pt-3",
                    children: filterData.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-center items-center w-full h-[246px]",
                        children: "No results found"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FixedSizeList */.t7, {
                        height: 246,
                        itemCount: filterData.length,
                        itemSize: 32,
                        width: "100%",
                        itemData: {
                            list: filterData,
                            activeItem: lodash_default().get(formik.values, path),
                            activeIndex: activeIndex,
                            onSelect: onSelect
                        },
                        className: "custom-scrollbar",
                        ref: listRef,
                        children: Row
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var form_TokenSelector = (TokenSelector);


/***/ }),

/***/ 28518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_T": function() { return /* binding */ TDK; },
/* harmony export */   "lU": function() { return /* binding */ serve_address; }
/* harmony export */ });
/* unused harmony export walletconnect_project_id */
var serve_address =  true ? "https://api.karatdao.com/action" : 0;
var walletconnect_project_id = "031d2b33f0e66c821d14c5bbaaa6b611";
var TDK = {
    title: "KaratForm: NFT Allowlist Collection Tool",
    description: "Easiest way to onboard web3 users with twitter, discord, and telegram. Launch a KaratForm to track and gain insights about your community under just one minute!",
    keywords: "KaratForm,Words: Premint Alternative,NFT allowlist,NFT allowlist,Wallet Collector,Address Collector,Wallet Management",
    cover: "https://s2.loli.net/2022/10/09/y4OKohqxgjZpT3W.jpg"
};


/***/ }),

/***/ 50072:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GS": function() { return /* binding */ nativeCurrencys; },
/* harmony export */   "yh": function() { return /* binding */ getBalanceOf; }
/* harmony export */ });
/* unused harmony exports Chains, RPC, supportedChains */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70655);
/* harmony import */ var _form_utils_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7395);



var getBalanceOf = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(data) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (data.addressList.length === 0) {
                        return [
                            2,
                            []
                        ];
                    }
                    return [
                        4,
                        _form_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].rpc */ .Z.rpc("chain/get_balance_of", data)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getBalanceOf(data) {
        return _ref.apply(this, arguments);
    };
}();
var Chains;
(function(Chains) {
    Chains[Chains["ETHEREUM"] = 1] = "ETHEREUM";
    Chains[Chains["BSC"] = 56] = "BSC";
    Chains[Chains["POLYGON"] = 137] = "POLYGON";
    Chains[Chains["AVALANCHE"] = 43114] = "AVALANCHE";
    Chains[Chains["GNOSIS"] = 100] = "GNOSIS";
    Chains[Chains["FANTOM"] = 250] = "FANTOM";
    Chains[Chains["ARBITRUM"] = 42161] = "ARBITRUM";
    Chains[Chains["CELO"] = 42220] = "CELO";
    Chains[Chains["HARMONY"] = 1666600000] = "HARMONY";
    Chains[Chains["GOERLI"] = 5] = "GOERLI";
    Chains[Chains["OPTIMISM"] = 10] = "OPTIMISM";
    Chains[Chains["MOONRIVER"] = 1285] = "MOONRIVER";
    Chains[Chains["RINKEBY"] = 4] = "RINKEBY";
    Chains[Chains["METIS"] = 1088] = "METIS";
    Chains[Chains["CRONOS"] = 25] = "CRONOS";
    Chains[Chains["BOBA"] = 288] = "BOBA";
    Chains[Chains["PALM"] = 11297108109] = "PALM";
    Chains[Chains["ZKSYNC"] = 324] = "ZKSYNC";
})(Chains || (Chains = {}));
var RPC = {
    ETHEREUM: {
        chainId: 1,
        chainName: "Ethereum",
        nativeCurrency: {
            name: "Ether",
            symbol: "ETH",
            decimals: 18,
            address: "0x0000000000000000000000000000000000000000",
            logoURI: "https://assets.coingecko.com/coins/images/279/small/ethereum.png?1595348880"
        },
        blockExplorerUrls: [
            "https://etherscan.io"
        ],
        apiUrl: "https://api.etherscan.io",
        iconUrls: [
            "/networkLogos/ethereum.svg"
        ]
    },
    BSC: {
        chainId: 56,
        chainName: "BSC",
        nativeCurrency: {
            name: "Binance Coin",
            symbol: "BNB",
            decimals: 18,
            address: "0x0000000000000000000000000000000000000000",
            logoURI: "https://assets.coingecko.com/coins/images/825/small/binance-coin-logo.png?1547034615"
        },
        blockExplorerUrls: [
            "https://bscscan.com"
        ],
        apiUrl: "https://api.bscscan.com",
        iconUrls: [
            "/networkLogos/bsc.svg"
        ]
    },
    POLYGON: {
        chainId: 137,
        chainName: "Polygon",
        nativeCurrency: {
            name: "Polygon",
            symbol: "MATIC",
            decimals: 18,
            address: "0x0000000000000000000000000000000000000000",
            logoURI: "https://assets.coingecko.com/coins/images/4713/small/matic-token-icon.png?1624446912"
        },
        blockExplorerUrls: [
            "https://polygonscan.com"
        ],
        apiUrl: "https://api.polygonscan.com",
        iconUrls: [
            "/networkLogos/polygon.svg"
        ]
    },
    AVALANCHE: {
        chainId: 43114,
        chainName: "Avalanche Mainnet",
        nativeCurrency: {
            name: "Avalanche",
            symbol: "AVAX",
            decimals: 18,
            address: "0x0000000000000000000000000000000000000000",
            logoURI: "https://assets.coingecko.com/coins/images/12559/small/coin-round-red.png?1604021818"
        },
        blockExplorerUrls: [
            "https://snowtrace.io"
        ],
        apiUrl: "https://api.snowtrace.io",
        iconUrls: [
            "/networkLogos/avalanche.svg"
        ]
    },
    GNOSIS: {
        chainId: 100,
        chainName: "Gnosis Chain",
        nativeCurrency: {
            name: "Gnosis",
            symbol: "Gnosis",
            decimals: 18,
            address: "0x0000000000000000000000000000000000000000",
            logoURI: "https://assets.coingecko.com/coins/images/11062/small/xdai.png?1614727492"
        },
        blockExplorerUrls: [
            "https://gnosisscan.io"
        ],
        apiUrl: "https://blockscout.com/xdai/mainnet",
        iconUrls: [
            "/networkLogos/gnosis.svg"
        ]
    },
    FANTOM: {
        chainId: 250,
        chainName: "Fantom Opera",
        nativeCurrency: {
            name: "Fantom",
            symbol: "FTM",
            decimals: 18,
            address: "0x0000000000000000000000000000000000000000",
            logoURI: "https://assets.coingecko.com/coins/images/4001/small/Fantom.png?1558015016"
        },
        blockExplorerUrls: [
            "https://ftmscan.com"
        ],
        apiUrl: "https://api.ftmscan.com",
        iconUrls: [
            "/networkLogos/fantom.svg"
        ]
    },
    ARBITRUM: {
        chainId: 42161,
        chainName: "Arbitrum One",
        nativeCurrency: {
            name: "Ether",
            symbol: "AETH",
            decimals: 18,
            address: "0x0000000000000000000000000000000000000000",
            logoURI: "https://assets.coingecko.com/coins/images/279/small/ethereum.png?1595348880"
        },
        blockExplorerUrls: [
            "https://arbiscan.io"
        ],
        apiUrl: "https://api.arbiscan.io",
        iconUrls: [
            "/networkLogos/arbitrum.svg"
        ]
    },
    CELO: {
        chainId: 42220,
        chainName: "Celo Mainnet",
        nativeCurrency: {
            name: "Celo",
            symbol: "CELO",
            decimals: 18,
            address: "0x0000000000000000000000000000000000000000",
            logoURI: "https://assets.coingecko.com/coins/images/11090/small/icon-celo-CELO-color-500.png?1592293590"
        },
        blockExplorerUrls: [
            "https://explorer.celo.org"
        ],
        apiUrl: "https://explorer.celo.org",
        iconUrls: [
            "/networkLogos/celo.svg"
        ]
    },
    HARMONY: {
        chainId: 1666600000,
        chainName: "Harmony",
        nativeCurrency: {
            name: "Harmony",
            symbol: "ONE",
            decimals: 18,
            address: "0x0000000000000000000000000000000000000000",
            logoURI: "https://assets.coingecko.com/coins/images/4344/small/Y88JAze.png?1565065793"
        },
        blockExplorerUrls: [
            "https://explorer.harmony.one"
        ],
        iconUrls: [
            "/networkLogos/harmony.svg"
        ]
    },
    OPTIMISM: {
        chainId: 10,
        chainName: "Optimism",
        nativeCurrency: {
            name: "Ether",
            symbol: "ETH",
            decimals: 18,
            address: "0x0000000000000000000000000000000000000000",
            logoURI: "https://assets.coingecko.com/coins/images/279/small/ethereum.png?1595348880"
        },
        blockExplorerUrls: [
            "https://optimistic.etherscan.io"
        ],
        apiUrl: "https://api-optimistic.etherscan.io",
        iconUrls: [
            "/networkLogos/optimism.svg"
        ]
    },
    MOONRIVER: {
        chainId: 1285,
        chainName: "Moonriver",
        nativeCurrency: {
            name: "Moonriver",
            symbol: "MOVR",
            decimals: 18,
            address: "0x0000000000000000000000000000000000000000",
            logoURI: "https://assets.coingecko.com/coins/images/17984/small/9285.png?1630028620"
        },
        blockExplorerUrls: [
            "https://moonriver.moonscan.io"
        ],
        apiUrl: "https://api-moonriver.moonscan.io",
        iconUrls: [
            "/networkLogos/moonriver.svg"
        ]
    },
    METIS: {
        chainId: 1088,
        chainName: "Metis Andromeda",
        nativeCurrency: {
            name: "Metis",
            symbol: "METIS",
            decimals: 18,
            address: "0x0000000000000000000000000000000000000000",
            logoURI: "https://assets.coingecko.com/coins/images/15595/small/metis.PNG?1621298076"
        },
        blockExplorerUrls: [
            "https://andromeda-explorer.metis.io"
        ],
        apiUrl: "https://andromeda-explorer.metis.io",
        iconUrls: [
            "/networkLogos/metis.svg"
        ]
    },
    CRONOS: {
        chainId: 25,
        chainName: "Cronos Mainnet",
        nativeCurrency: {
            name: "Cronos",
            symbol: "CRO",
            decimals: 18,
            address: "0x0000000000000000000000000000000000000000",
            logoURI: "https://assets.coingecko.com/coins/images/7310/small/oCw2s3GI_400x400.jpeg?1645172042"
        },
        blockExplorerUrls: [
            "https://cronos.org/explorer"
        ],
        apiUrl: "https://cronos.org/explorer",
        iconUrls: [
            "/networkLogos/cronos.svg"
        ]
    },
    BOBA: {
        chainId: 288,
        chainName: "Boba Network",
        nativeCurrency: {
            name: "Ether",
            symbol: "ETH",
            decimals: 18,
            address: "0x0000000000000000000000000000000000000000",
            logoURI: "https://assets.coingecko.com/coins/images/279/small/ethereum.png?1595348880"
        },
        blockExplorerUrls: [
            "https://blockexplorer.boba.network"
        ],
        apiUrl: "https://api.bobascan.com",
        iconUrls: [
            "/networkLogos/boba.svg"
        ]
    },
    PALM: {
        chainId: 11297108109,
        chainName: "Palm",
        nativeCurrency: {
            name: "Palm",
            symbol: "PALM",
            decimals: 18,
            address: "0x0000000000000000000000000000000000000000",
            logoURI: "/networkLogos/palm.png"
        },
        blockExplorerUrls: [
            "https://explorer.palm.io"
        ],
        apiUrl: "https://explorer.palm.io",
        iconUrls: [
            "/networkLogos/palm.png"
        ]
    },
    RINKEBY: {
        chainId: 4,
        chainName: "Rinkeby",
        nativeCurrency: {
            name: "Rinkeby Ether",
            symbol: "rETH",
            decimals: 18,
            address: "0x0000000000000000000000000000000000000000",
            logoURI: "https://assets.coingecko.com/coins/images/279/small/ethereum.png?1595348880"
        },
        blockExplorerUrls: [
            "https://rinkeby.etherscan.io"
        ],
        apiUrl: "https://api-rinkeby.etherscan.io",
        iconUrls: [
            "/networkLogos/ethereum.svg"
        ]
    },
    GOERLI: {
        chainId: 5,
        chainName: "Goerli",
        nativeCurrency: {
            name: "Ether",
            symbol: "ETH",
            decimals: 18,
            address: "0x0000000000000000000000000000000000000000",
            logoURI: "https://assets.coingecko.com/coins/images/279/small/ethereum.png?1595348880"
        },
        blockExplorerUrls: [
            "https://goerli.etherscan.io"
        ],
        apiUrl: "https://api-goerli.etherscan.io",
        iconUrls: [
            "/networkLogos/ethereum.svg"
        ]
    },
    ZKSYNC: {
        chainId: 324,
        chainName: "zkSync",
        nativeCurrency: {
            name: "Ether",
            symbol: "ETH",
            decimals: 18,
            address: "0x0000000000000000000000000000000000000000",
            logoURI: "https://assets.coingecko.com/coins/images/279/small/ethereum.png?1595348880"
        },
        blockExplorerUrls: [
            "https://explorer.zksync.io"
        ],
        iconUrls: [
            "https://portal.zksync.io/favicon.ico"
        ]
    }
};
var supportedChains = Object.keys(RPC);
var nativeCurrencys = {};
supportedChains.forEach(function(chain) {
    nativeCurrencys[RPC[chain].chainId] = RPC[chain].nativeCurrency;
    nativeCurrencys[RPC[chain].chainId].chainId = RPC[chain].chainId;
});


/***/ }),

/***/ 16385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AE": function() { return /* binding */ AvailableNetworks; }
/* harmony export */ });
/* unused harmony exports BSCIcon, EthereumIcon, PolygonIcon, AvalancheIcon */
/* harmony import */ var wagmi_chains__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31407);

var BSCIcon = "/airdrop_assets/network/bsc.png";
var EthereumIcon = "/airdrop_assets/network/ethereum.png";
var PolygonIcon = "/airdrop_assets/network/polygon-matic-logo.png";
var AvalancheIcon = "/airdrop_assets/network/avalanche-avax-logo.png";
var AvailableNetworks = [
    {
        config: wagmi_chains__WEBPACK_IMPORTED_MODULE_0__/* .mainnet */ .RJ,
        name: "Ethereum",
        isTestNetwork: false,
        icon: EthereumIcon
    },
    {
        config: wagmi_chains__WEBPACK_IMPORTED_MODULE_0__/* .polygon */ .yu,
        name: "Polygon",
        isTestNetwork: false,
        icon: PolygonIcon
    },
    {
        config: wagmi_chains__WEBPACK_IMPORTED_MODULE_0__/* .avalanche */ .pL,
        name: "Avalanche",
        isTestNetwork: false,
        icon: AvalancheIcon
    },
    {
        config: wagmi_chains__WEBPACK_IMPORTED_MODULE_0__/* .bsc */ .eG,
        name: "BSC",
        isTestNetwork: false,
        icon: BSCIcon
    },
    {
        config: wagmi_chains__WEBPACK_IMPORTED_MODULE_0__/* .zkSync */ .jM,
        name: "zkSync",
        isTestNetwork: false,
        icon: "https://portal.zksync.io/favicon.ico"
    },
    {
        config: wagmi_chains__WEBPACK_IMPORTED_MODULE_0__/* .goerli */ .ws,
        name: "Goerli",
        isTestNetwork: true,
        icon: EthereumIcon
    }, 
];
if (false) {}


/***/ }),

/***/ 7395:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70655);
/* harmony import */ var umi_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11238);
/* harmony import */ var _stores__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27234);
/* harmony import */ var _config_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28518);
/* harmony import */ var _config_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35055);
/**
 * request 网络请求工具
 * 更详细的 api 文档: https://github.com/umijs/umi-request
 */ 





var codeMessage = {
    200: "服务器成功返回请求的数据。",
    201: "新建或修改数据成功。",
    202: "一个请求已经进入后台排队（异步任务）。",
    204: "删除数据成功。",
    400: "发出的请求有错误，服务器没有进行新建或修改数据的操作。",
    401: "用户没有权限（令牌、用户名、密码错误）。",
    403: "用户得到授权，但是访问是被禁止的。",
    404: "发出的请求针对的是不存在的记录，服务器没有进行操作。",
    406: "请求的格式不可得。",
    410: "请求的资源被永久删除，且不会再得到的。",
    422: "当创建一个对象时，发生一个验证错误。",
    500: "服务器发生错误，请检查服务器。",
    502: "网关错误。",
    503: "服务不可用，服务器暂时过载或维护。",
    504: "网关超时。"
};
/**
 * 异常处理程序
 */ var errorHandler = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(error) {
        var response, errorText;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    response = error.response;
                    if (!(response && response.status)) return [
                        3,
                        2
                    ];
                    errorText = codeMessage[response.status] || response.statusText;
                    if (!!errorText) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        response.text()
                    ];
                case 1:
                    errorText = _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        2,
                        response
                    ];
            }
        });
    });
    return function errorHandler(error) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * 配置request请求时的默认参数
 */ var request = (0,umi_request__WEBPACK_IMPORTED_MODULE_0__/* .extend */ .l7)({
    errorHandler: errorHandler,
    // 默认错误处理
    credentials: "include",
    timeout: 10000
});
request.rpc = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(method) {
        var params, headers, myHeaders, session, raw, requestOptions, response, err, resp;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : [], headers = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : {};
                    if (_config_config__WEBPACK_IMPORTED_MODULE_3__/* .isMaintenance */ .b6) {
                        throw new Error(_config_config__WEBPACK_IMPORTED_MODULE_3__/* .maintenanceApiMessage */ .Bn);
                    }
                    myHeaders = new Headers();
                    myHeaders.append("Content-Type", "application/json");
                    myHeaders.append("ref",  true ? window.location.href : 0);
                    session = _stores__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getState */ .ZP.getState().account.session;
                    if (session) {
                        myHeaders.append("token", session.token);
                    }
                    Object.keys(headers).forEach(function(key) {
                        myHeaders.append(key, headers[key]);
                    });
                    raw = JSON.stringify({
                        method: method,
                        params: params
                    });
                    requestOptions = {
                        method: "POST",
                        headers: myHeaders,
                        body: raw,
                        redirect: "follow"
                    };
                    response = null;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        fetch( true ? _config_config__WEBPACK_IMPORTED_MODULE_2__/* .serve_address */ .lU : 0, requestOptions)
                    ];
                case 2:
                    response = _state.sent();
                    // console.log(response);
                    if (response.status !== 200) {
                        errorHandler({
                            response: response
                        });
                        return [
                            2,
                            null
                        ];
                    }
                    return [
                        3,
                        4
                    ];
                case 3:
                    err = _state.sent();
                    throw err;
                case 4:
                    return [
                        4,
                        response.json()
                    ];
                case 5:
                    resp = _state.sent();
                    if ("error" in resp) {
                        if (resp.error.message === "Token is not valid. Please login again") {
                            _stores__WEBPACK_IMPORTED_MODULE_1__/* ["default"].dispatch */ .ZP.dispatch(_stores__WEBPACK_IMPORTED_MODULE_1__/* .actions.account.removeSession */ .Nw.account.removeSession());
                        }
                        throw resp.error;
                    } else if ("result" in resp) {
                        return [
                            2,
                            resp.result
                        ];
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return function(method) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["Z"] = (request);


/***/ }),

/***/ 69545:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ uriToHttp; }
/* harmony export */ });
/**
 * Given a URI that may be ipfs, ipns, http, https, ar, or data protocol, return the fetch-able http(s) URLs for the same content
 * @param uri to convert to fetch-able http url
 */ function uriToHttp(uri) {
    var protocol = uri === null || uri === void 0 ? void 0 : uri.split(":")[0].toLowerCase();
    switch(protocol){
        case "data":
            return [
                uri
            ];
        case "https":
            return [
                uri
            ];
        case "http":
            return [
                "https" + uri.substr(4),
                uri
            ];
        case "ipfs":
            var ref;
            var hash = (ref = uri.match(/^ipfs:(\/\/)?(.*)$/i)) === null || ref === void 0 ? void 0 : ref[2];
            return [
                "https://karatdao.mypinata.cloud/ipfs/".concat(hash, "/")
            ];
        case "ipns":
            var ref1;
            var name = (ref1 = uri.match(/^ipns:(\/\/)?(.*)$/i)) === null || ref1 === void 0 ? void 0 : ref1[2];
            return [
                "https://ipfs.io/ipns/".concat(name, "/")
            ];
        case "ar":
            var ref2;
            var tx = (ref2 = uri.match(/^ar:(\/\/)?(.*)$/i)) === null || ref2 === void 0 ? void 0 : ref2[2];
            return [
                "https://arweave.net/".concat(tx)
            ];
        default:
            return [];
    }
}


/***/ }),

/***/ 65746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "At": function() { return /* binding */ isValidAddress; },
/* harmony export */   "HG": function() { return /* binding */ validateDiscordChannelLink; },
/* harmony export */   "JO": function() { return /* binding */ validateTwitterLink; },
/* harmony export */   "Zh": function() { return /* binding */ validateDiscordServerLink; },
/* harmony export */   "oH": function() { return /* binding */ validateEmail; },
/* harmony export */   "s_": function() { return /* binding */ validateSendingMeSquadLink; }
/* harmony export */ });
/* unused harmony export validateTelegramGroupLink */
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7258);

var validateEmail = function(email) {
    if (!email) {
        return false;
    }
    return yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().email().isValidSync(email);
};
var RTwitterLink = /^https:\/\/twitter.com\/[^/]+\/status\/\d+/;
var validateTwitterLink = function(url) {
    if (!url) {
        return false;
    }
    return RTwitterLink.test(url);
};
var validateDiscordServerLink = function(url) {
    if (!url) {
        return false;
    }
    return url.indexOf("https://discord.gg/") === 0 || url.indexOf("https://discord.com/invite") === 0;
};
var validateSendingMeSquadLink = function(url) {
    if (!url) {
        return false;
    }
    return url.indexOf("sending.me/share/?squad=") > 0;
};
var validateDiscordChannelLink = function(url) {
    if (!url) {
        return false;
    }
    return url.indexOf("https://discord.com/channels") === 0;
};
var RTelegramGroupLink = /^https:\/\/t.me\/./;
var validateTelegramGroupLink = function(url) {
    if (!url) {
        return false;
    }
    return RTelegramGroupLink.test(url);
};
var REGEX_ADDRESS = /^0x[A-F0-9]{40}$/i;
var isValidAddress = function(address) {
    return REGEX_ADDRESS.test(address);
};


/***/ })

}]);